 blue.ready('tabs', '.tabs', tab => {
	const params = new URLSearchParams(window.location.search)
	const triggers = [...tab.querySelectorAll('.tab-trigger')]
	const contents = [...tab.querySelectorAll('.tab-content')]

	const select = function() {
		let index = triggers.indexOf(this)
		let dest = this.getAttribute('data-tab')
		triggers.forEach(trigger => trigger.classList.remove('is-active'))
		contents.forEach(content => content.classList.remove('is-active'))

		triggers[index].classList.add('is-active')
		contents[index].classList.add('is-active')

		params.set('tab', dest)
		var location = window.location.search.replace("?", "");
		if (location != params)
		{
			window.history.replaceState( {} , "title", `${window.location.origin}${window.location.pathname}?${params.toString()}` )
		}
		
	}

	triggers.forEach(trigger => trigger.addEventListener('click', select))
})

blue.ready('tab_links', '.tabs', tab => {
	const params = new URLSearchParams(window.location.search)
	const links = [...document.querySelectorAll('a[data-tab]')]
	const tabs = [...document.querySelectorAll('.tab-trigger')]

	const followLink = function(e) {
		e.preventDefault()
		let dest = this.getAttribute('data-tab')
		let title = document.querySelector('title').textContent || ""
		tabs.filter(tab => tab.getAttribute('data-tab') == dest)[0].click()
		params.set('tab', dest)
		window.history.replaceState( {} , "title", `${window.location.origin}${window.location.pathname}?${params.toString()}` );
	}

	links.forEach(link => link.addEventListener('click', followLink))
})

blue.ready('tab_hash', '.tabs', tab => {
	const params = new URLSearchParams(window.location.search)
	const tabs = [...document.querySelectorAll('.tab-trigger')]

	if (params.has("tab")) {
		let thisTab = tabs.filter(tab => tab.getAttribute('data-tab') == params.get("tab"))[0]
		
		if (thisTab) {
			thisTab.click()
		}
	}
})